import moment from "moment";
import {
  GET_ORDER,
  SET_ORDER_BY,
  SET_PAGE,
  SET_REFUND_STATUS,
  SET_SEARCH,
  SET_SORT_BY,
} from "../../shared/constants/ActionTypes";

const initialOrders = {
  orders: [],
  orderCount: 0,
  page: 1,
  search: "",
  orderby: "desc",
  sortby: "",
  refundStatus:"",
};

const orderReducer = (state = initialOrders, action) => {
  switch (action.type) {
    case GET_ORDER:
      return {
        ...state,
        orders: action.payload.orders.map((order) => {
          return {
            ...order,
            updatedAtFormatted: moment(order.createdAt).format("ll"),
            priceFormatted: order.grandTotal
              ? `${order.grandTotal[order.currency]} ${
                  order.currency == "EURO" ? "€" : "$"
                }`
              : order.grandTotal == "0"
              ? "FREE"
              : "",
            userType: order.studentId ? "Student" : "Instructor",
            fullName: order.studentId
              ? `${order.studentId?.firstName}  ${order.studentId?.lastName}`
              : `${order.tutorId?.firstName}  ${order.tutorId?.lastName}`,
          };
        }),
        orderCount: action.payload.totalCount,
      };

    case SET_PAGE:
      return {
        ...state,
        page: action.payload,
      };

    case SET_SEARCH:
      return {
        ...state,
        search: action.payload,
      };
    case SET_ORDER_BY:
      return {
        ...state,
        orderby: action.payload,
      };
    case SET_SORT_BY:
      return {
        ...state,
        sortby: action.payload,
      };
      case SET_REFUND_STATUS:
        return {
          ...state,
          refundStatus: action.payload,
        };
    default:
      return state;
  }
};

export default orderReducer;
